import React, { useEffect, useState } from 'react';
import { Col, Row } from "react-bootstrap";

function AppWebReportStundenMaterial(props) {

    const [materialData, setMaterialData] = useState([]);

    useEffect(() => {
        if(props.materialData===undefined){
            setMaterialData([]);
        }
        else{
            setMaterialData(props.materialData)
        }
    }, [props.materialData]);

    function getMaterialTableBody(material) {
        return material?.map((item, i) => (
            <TableRow
                key={i.toString()}
                item={item}
            />
        ));
    }

    return (<>
        <Row>
            <Col>
                <label className="handwai-text-label-main add-bottom-0-margin">{"Material"}</label>
            </Col>

        </Row>
        <br />
        <table id="materialTable" className="table handwai-white-text">
            <thead>
                <tr>
                    <th>Position</th>
                    <th>Kurztext</th>
                    <th>Einheit</th>
                    <th>Menge</th>
                    <th>Teilaufmaß</th>
                </tr>
            </thead>
            <tbody>{getMaterialTableBody(materialData)}</tbody>
        </table>
    </>);
}

export default AppWebReportStundenMaterial;

const TableRow = ({ item }) => {
    return (
        <tr key={item.id} style={{ backgroundColor: item.position === "-" ? '#c6a500' : 'inherit' }}>
            <td>{item.position}</td>
            <td>{item.description}</td>
            <td>{item.unit}</td>
            <td>{item.menge}</td>
            <td>{item.aufmas}</td>
        </tr>
    )
}